import RestaurantMinimums from '../features/restaurants/RestaurantMinimums';

export default function RestaurantsPage() {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Restoran Ayarları</h1>
        <p>Minimum sipariş limitlerini ve servis durumlarını buradan yönetin.</p>
      </div>

      <div className="page-section">
        <RestaurantMinimums />
      </div>
    </div>
  );
}
